<template>
  <div class="h-full flex flex-col">
    <div :class="isMobile ? 'text-center' : ''">
      <div class="text-justify">
        <img v-if="isMobile" src="@/assets/images/title-mb.png" class="w-[320px] md:w-[480px]" alt="" />
        <img v-else src="@/assets/images/title.png" class="w-[600px]" alt="" />
      </div>
      <ul class="mt-2 text-[13px] xl:text-[16px] text-justify" :class="isMobile ? 'text-[13px]' : ''">
        <li>Đối tượng áp dụng:  Khách hàng đăng ký học chương trình "THE FRESH DEAL – FOR THE FRESHERS" thành công</li>
        <li class="">Thời gian quay thưởng: Từ 12/8/2025 đến 15/8/2025</li>
      </ul>
    </div>
    <div class="mt-4 flex flex-col flex-grow">
      <h2 class="text-[18px] xl:text-[20px] font-bold mb-[8px]" :class="isMobile ? ' rounded-[30px] ' : ''">
        <span>
          Lịch sử quà tặng
        </span>
      </h2>
      <div class="bg-[#FFC940] rounded-[30px] p-2 h-full">
        <div class="grid grid-cols-2">
          <div class="flex justify-center">
            <button
                :class="isHistory? 'bg-black text-white px-4 rounded-full md:bg-transparent md:text-black md:border-b-2 md:border-black md:px-0 md:rounded-none': ''"
                @click="$emit('history')"
                class="text-[11px] md:text-[18px] w-fit text-center font-bold whitespace-nowrap uppercase"
            >
              <span>Tất cả người chơi</span>
            </button>
          </div>
          <div class="flex justify-center">
            <button
                :class="!isHistory? 'bg-black text-white px-4 rounded-full md:bg-transparent md:text-black md:border-b-2 md:border-black md:px-0 md:rounded-none': ''"
                @click="$emit('myGift')"
                class="text-[11px] md:text-[18px] w-fit text-center font-bold whitespace-nowrap uppercase"
            >
              <span>Quà tặng của tôi</span>
            </button>
          </div>
        </div>
        <div class="relative">
          <img class="absolute h-[55px] right-[-20px] top-[-80px] md:h-[80px] md:right-[-50px] md:top-[-100px] xl:top-[-120px] xl:right-0 z-[120] xl:h-[50px]" src="@/assets/images/bird-right.png" alt="">
          <div class="items-center justify-center gap-2 bg-cover p-2">
            <TableHistoryWeb :data-table="isHistory ? dataTable : dataGift" :is-history="isHistory" :is-login="isLogin" v-if="!isMobile"/>
            <TableHistoryMobile v-else :data-table="isHistory ? dataTable : dataGift" :is-history="isHistory" :is-login="isLogin"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TableHistoryWeb from "@/pages/version2/components/TableHistoryWeb.vue";
import TableHistoryMobile from "@/pages/version2/components/TableHistoryMobile.vue";

export default {
  components: {TableHistoryMobile, TableHistoryWeb},
  setup() {
    return {}
  },
  data() {
    return {
      baseUrlImage: 'https://ieltsmentor.edu.vn/wp-content/uploads/2024/12/'
    }
  },
  props: {
    dataTable: {
      type: [],
      default: []
    },
    isHistory: {
      type: Boolean,
      default: false
    },
    dataGift: {
      type: [],
      default: []
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    isMobile: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style scoped></style>
